import React, { createContext } from "react";
import { useExpanded, useFilters, useTable } from "react-table";
import { RequisitionsListTableBody } from "./RequisitionsListTableBody";
import { RequsitionsListTableHead } from "./RequisitionsListTableHead";

export const TableContext = createContext({});

export const RequisitionsListTable = ({
  columns,
  data,
  filters = {},
  checkFilter,
  id,
  ...props
}) => {
  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: { hiddenColumns: ["status"] },
    },
    useFilters,
    useExpanded
  );
  const { getTableProps } = tableInstance;

  return (
    <TableContext.Provider value={{ ...tableInstance }}>
      <table className="myTable" {...getTableProps()}>
        <RequsitionsListTableHead />
        <RequisitionsListTableBody id={id} {...props} />
      </table>
    </TableContext.Provider>
  );
};
